export const IMAGES = [
  
  { src: "https://i.ibb.co/jTgGWX9/image.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/gtBtFbs/1.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/vshzTWg/2.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/g7TKb4c/3.jpg", thumbnail: "" },
  
];